import { ProgressSpinner } from 'primereact/progressspinner';
import { ReactElement } from 'react';
import './Spinner.scss';

export default function Spinner({
  className = '',
}: {
  className?: string;
}): ReactElement {
  return (
    <div className={className ? `loader ${className}` : 'loader'}>
      <div className="loader--content">
        <ProgressSpinner
          style={{ width: '50px', height: '50px' }}
          strokeWidth="4"
        />
        <span>Loading ...</span>
      </div>
    </div>
  );
}
